import type { IPromotion } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Promotion';
import type { IPublishTerm } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { IPromotionState } from '../../../../reducers/v2';
import { mapDurations } from './mapDurations';
import { mapPromotionService } from './mapPromotionService';
import { mapAuctionBet } from './mapAuctionBet';
import { mapToggle } from './mapToggle';

export function mapPromotion(promotion: IPromotion, terms: IPublishTerm[]): Omit<IPromotionState, 'isChangedByUser'> {
  return {
    duration: mapDurations(promotion.durations || []),
    restriction: promotion.restriction,
    services: promotion.promotionTypes?.map(service => mapPromotionService(service, terms)) || [],
    auctionBet: mapAuctionBet(promotion.auctionBet),
    toggle: mapToggle(promotion.toggle),
    competitors: [],
  };
}
